import { AxiosError } from 'axios';

export function getError(error: unknown) {
  return (error as AxiosError).response?.data;
}

export function getNonFieldError(error: unknown) {
  return (error as AxiosError).response?.data.non_field_errors?.[0] ?? null;
}

export function getErrors(error: unknown) {
  return (error as AxiosError).response?.data;
}
